import { useSelector } from 'react-redux';

const useAuthToken = () => {
  return useSelector((state: any) => state.auth.token);
};

export default useAuthToken;
